// MuiCard-root
import { darkPalette } from "../palette";

export const MuiCard = {
  MuiCard: {
    styleOverrides: {
      root: {
        backgroundColor: darkPalette.background.paper,
        color: darkPalette.text.secondary,
        "&:hover": {
          borderColor: darkPalette.primary.main,
        },
      },
    },
  },
};
